__turbopack_context__.v({
  "ingredientsBox": "ingredients-module___nPdeG__ingredientsBox",
  "ingredientsButton": "ingredients-module___nPdeG__ingredientsButton",
  "ingredientsContainer": "ingredients-module___nPdeG__ingredientsContainer",
});
